import { useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import store from '@/redux/store';

type InferredRootState = ReturnType<typeof store.getState>;
type InferredAuthState = InferredRootState extends { auth: infer Auth } ? Auth : Record<string, never>;
type InferredAuthWithoutUser = InferredAuthState extends object ? Omit<InferredAuthState, 'user'> : Record<string, never>;

export interface AuthUser {
  id?: number | string;
  firmId?: number | null;
  firstName?: string;
  lastName?: string;
  email?: string;
  profilePicture?: string;
  permissions?: Record<string, boolean | undefined>;
  subscription?: { planName?: string; isExtendedTrial?: boolean };
  deepScanAllowed?: boolean;
}

interface EntitySearchParams {
  pageNumber?: number;
  pageSize?: number;
  searchQuery?: string;
  sortColumn?: string;
  sortDirection?: string;
  filterValues?: Record<string, string | number | boolean | null | undefined>;
  visibleFilterKeys?: string[] | null;
  scopeCompanyIds?: number[];
  scopeProductIds?: number[];
}

export type RootState = Omit<InferredRootState, 'auth' | 'promptOptimizer' | 'searchParams'> & {
  auth: InferredAuthWithoutUser & {
    user?: AuthUser | null;
  };
  promptOptimizer: {
    isPromptOptimizerEnabled: boolean;
  };
  searchParams: {
    searchParams: Record<string, EntitySearchParams | undefined>;
  };
};

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
